import axios from "axios";
import { HOST } from "config/config";
import tableDataQueryStringBuilder from "utils/tableData";

export function getTaxTypeTargets(tableDataParam, forceRefresh = false) {
  return (dispatch, getState) => {
    if (!getState().taxTypeTargetsReducer.updating || forceRefresh) {
      if (tableDataParam === undefined) {
        return dispatch({
          type: "GET_TAX_TYPE_TARGETS_PENDING",
          payload: axios
            .get(`${HOST}/api/tax-type-targets`)
            .then(response => response.data)
            .then(json =>
              dispatch({
                type: "GET_TAX_TYPE_TARGETS_FULFILLED",
                payload: {
                  items: json
                }
              })
            )
            .catch(error =>
              dispatch({
                type: "SHOW_MESSAGE",
                payload: {
                  type: "error",
                  titleKey: "error",
                  message: error.message
                }
              })
            )
        });
      }

      return dispatch({
        type: "GET_TAX_TYPE_TARGETS_PENDING",
        payload: axios
          .get(`${HOST}/api/tax-type-targets`, {
            paramsSerializer: params => tableDataQueryStringBuilder(params),
            params: tableDataParam
          })
          .then(response => response.data)
          .then(json => {
            if (tableDataParam) {
              dispatch({
                type: "UPDATE_TAX_TYPE_TARGETS_TABLEDATAPARAM",
                payload: tableDataParam
              });
            }

            dispatch({
              type: "GET_TAX_TYPE_TARGETS_FULFILLED",
              payload: json
            });
          })
          .catch(error =>
            dispatch({
              type: "GET_TAX_TYPE_TARGETS_REJECTED",
              payload: error
            })
          )
      });
    }
  };
}

export function getTaxTypeTargetsForSelect() {
  return (dispatch, getState) => {
    if (!getState().taxTypeTargetsReducer.updating) {
      return dispatch({
        type: "GET_TAX_TYPE_TARGETS_PENDING",
        payload: axios
          .get(`${HOST}/api/tax-type-targets`)
          .then(response => response.data)
          .then(json =>
            dispatch({
              type: "GET_TAX_TYPE_TARGETS_SELECT_FULFILLED",
              payload: json
            })
          )
          .catch(error =>
            dispatch({
              type: "SHOW_MESSAGE",
              payload: {
                type: "error",
                titleKey: "error",
                message: error.message
              }
            })
          )
      });
    }
  };
}

export function getTaxTypeTarget(taxTypeTargetId, forceRefresh = false) {
  return (dispatch, getState) => {
    if (!getState().taxTypeTargetsReducer.updating || forceRefresh) {
      if (taxTypeTargetId === 0) {
        return dispatch({
          type: "GET_TAX_TYPE_TARGET_FULFILLED",
          payload: {
            id: 0,
            internalName: "",
            nameFrench: "",
            nameEnglish: "",
            createdDate: new Date()
          }
        });
      }
      return dispatch({
        type: "GET_TAX_TYPE_TARGET_PENDING",
        payload: axios
          .get(`${HOST}/api/tax-type-targets/${taxTypeTargetId}`)
          .then(response => response.data)
          .then(json =>
            dispatch({
              type: "GET_TAX_TYPE_TARGET_FULFILLED",
              payload: json
            })
          )
          .catch(error =>
            dispatch({
              type: "GET_TAX_TYPE_TARGET_REJECTED",
              payload: error
            })
          )
      });
    }
  };
}

export function updateTaxTypeTarget(taxTypeTarget) {
  return dispatch =>
    dispatch({
      type: "UPDATE_TAX_TYPE_TARGET",
      payload: taxTypeTarget
    });
}

export function persistTaxTypeTarget(taxTypeTarget) {
  return (dispatch, getState) => {
    if (!getState().taxTypeTargetsReducer.updating) {
      return new Promise((resolve, reject) =>
        dispatch({
          type: "PERSISTING_TAX_TYPE_TARGET",
          payload: (taxTypeTarget.id === 0
            ? axios.post(`${HOST}/api/tax-type-targets`, taxTypeTarget)
            : axios.put(`${HOST}/api/tax-type-targets/${taxTypeTarget.id}`, taxTypeTarget)
          )
            .then(response => response.data)
            .then(json => {
              dispatch({
                type: "PERSISTED_TAX_TYPE_TARGET",
                payload: {
                  taxTypeTarget: json,
                  isNew: taxTypeTarget.id === 0
                }
              });

              dispatch({
                type: "SHOW_MESSAGE",
                payload: {
                  type: "success",
                  titleKey: "success",
                  messageKey: "saved_successful"
                }
              });
              return resolve();
            })
            .catch(error => {
              dispatch({
                type: "SHOW_MESSAGE",
                payload: {
                  type: "error",
                  titleKey: "error",
                  message: error.response
                }
              });
              return reject();
            })
        })
      );
    }
  };
}
